import {
  Box,
  Typography,
  IconButton,
  Tabs,
  Tab,
  InputBase,
  Divider,
  MenuItem,
  Select,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FitScreenIcon from "@mui/icons-material/FitScreen";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import SearchIcon from "@mui/icons-material/Search";
import { useState } from "react";

export default function MobileCustomize({
  showcaseId,
  sessionId,
  mainTitle,
  modelTitle,
  productData,
}) {
  const accessoriesData = productData?.[0]?.accessories || [];

  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("low");

  const filteredAccessories = accessoriesData
    .filter((acc) =>
      acc.display_name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      const priceA = parseInt(a.price);
      const priceB = parseInt(b.price);
      return sortOrder === "low" ? priceA - priceB : priceB - priceA;
    });

  return (
    <Box sx={{ width: "100%", bgcolor: "#fff" }}>
      {/* Car Image */}
      <Box sx={{ position: "relative", height: "35vh" }}>
        <iframe
          src={`https://canvas005.atttic.com/?showcase=${showcaseId}+&product=01+&session=${sessionId}`}
          width="100%"
          height="100%"
          frameBorder="0"
          loading="lazy"
        />
        <Box
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            display: "flex",
            gap: 1,
          }}
        >
          <IconButton size="small">
            <ViewInArIcon />
          </IconButton>
          <IconButton size="small">
            <FitScreenIcon />
          </IconButton>
        </Box>
        <Box
          sx={{
            position: "absolute",
            top: 12,
            left: 12,
            bgcolor: "white",
            px: 1,
            py: 0.5,
            borderRadius: 1,
            fontSize: "0.85rem",
            fontWeight: 500,
            boxShadow: 1,
          }}
        >
          ₹ 7 37 000
        </Box>
      </Box>

      {/* Accessories Section */}
      <Box p={2}>
        <Box style={{ border: "1px solid grey", padding: "20px" }}>
          <Typography variant="h6" gutterBottom>
            Accessories
          </Typography>
          <Typography variant="body2" mb={2}>
            {`Choose from our exclusive selection of accessories for ${mainTitle}.`}
          </Typography>

          {/* Tabs */}
          <Tabs
            value={0}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ mb: 2 }}
          >
            <Tab label="All" />
            <Tab label="Exterior" />
            <Tab label="Lifestyle" />
            <Tab label="Interior" />
          </Tabs>

          {/* Search and Sort */}
          <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2 }}>
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                border: "1px solid #ccc",
                borderRadius: 1,
                px: 1,
              }}
            >
              <SearchIcon fontSize="small" />
              <InputBase
                placeholder="Search"
                sx={{ ml: 1, flex: 1 }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Box>

            <Select
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              size="small"
              sx={{ fontSize: "0.85rem", minWidth: 140 }}
            >
              <MenuItem value="low">Price: Low to High</MenuItem>
              <MenuItem value="high">Price: High to Low</MenuItem>
            </Select>
          </Box>

          {/* Accessories List */}
          {filteredAccessories.map((item, idx) => {
            const image = item.accessory_icons?.find(
              (icon) => icon.file_type === "M"
            )?.path;

            return (
              <Box
                key={item.accessory_id}
                sx={{
                  mb: 2,
                  display: "flex",
                  gap: 2,
                  alignItems: "center",
                }}
              >
                <Box
                  component="img"
                  src={image}
                  alt={item.display_name}
                  sx={{
                    width: 80,
                    height: 60,
                    borderRadius: 1,
                    objectFit: "cover",
                    bgcolor: "#eee",
                  }}
                />
                <Box sx={{ flex: 1 }}>
                  <Typography fontSize="0.9rem" fontWeight={500}>
                    {item.display_name}
                  </Typography>
                  <Typography
                    fontSize="0.85rem"
                    color="text.secondary"
                    mt={0.5}
                  >
                    ₹{item.price}
                  </Typography>
                </Box>
                <Box sx={{ alignSelf: "center" }}>
                  <Typography
                    sx={{
                      border: "1px solid",
                      borderRadius: 1,
                      px: 1.5,
                      py: 0.5,
                      fontSize: "0.8rem",
                      cursor: "pointer",
                    }}
                  >
                    Add +
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}
